import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsSupportWebsiteOverviewRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-support-website-details-overview',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/overview',
	exact: true,
};
